/**
 |--------------------------------------------------------------------------
 | COMPANIES : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const companies = [
    {
        path: '/companies/all', component: require('pages/companies/all.vue').default,
        name: 'all_companies',
        meta: { requiresAuth: true, title: "All Companies", icon: "fas fa-city" }
    }, {
        path: '/companies/create', component: require('pages/companies/create.vue').default,
        name: 'create_company',
        meta: { requiresAuth: true, title: "Create Company", icon: "fas fa-building" }
    }, {
        path: '/company/record', component: require('pages/companies/record.vue').default,
        // path: '/company/record/:id?', component: require('pages/companies/record.vue').default,
        name: 'company_record',
        meta: {
            requiresAuth: true,
            title: "Company Record",
            // title: route => `${route.params.id}`,
            // key: 'fullPath',
            icon: "fas fa-store-alt"
        }
    },
    {
        path: '/companies/import', component: require('pages/companies/import.vue').default,
        name: 'import_company',
        meta: {requiresAuth: true, title: "Import Company(s)", icon: "fas fa-upload"}
       },
    {
        path: '/companies/planner', component: require('pages/companies/planner.vue').default,
        name: 'journey_planner',
        meta: { requiresAuth: true, title: "Journey Planner", icon: "fas fa-marker" }
    },
];
export default companies;
